import { render, staticRenderFns } from "./dropdown-list-item.vue?vue&type=template&id=bdd03394&scoped=true&"
import script from "./dropdown-list-item.vue?vue&type=script&lang=js&"
export * from "./dropdown-list-item.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-list-item.vue?vue&type=style&index=0&id=bdd03394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd03394",
  null
  
)

export default component.exports